import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './Home.css';

function Home({ userId }) {
  const [nickname, setNickname] = useState('');

  useEffect(() => {
    if (userId) {
      const fetchUserProfile = async () => {
        try {
          const response = await fetch('/api/me', {  // Updated to relative path
            credentials: 'include',
          });
          const data = await response.json();
          if (data.success) {
            setNickname(data.nickname || `User ID: ${userId}`); // Fallback to userId if nickname is not available
          } else {
            setNickname(`User ID: ${userId}`);
          }
        } catch (error) {
          console.error('Error fetching user profile:', error);
          setNickname(`User ID: ${userId}`);
        }
      };
      fetchUserProfile();
    }
  }, [userId]);

  return (
    <div className={userId ? 'home-container user-home' : 'home-container static-home'}>
      <div className="home-card">
        {userId ? (
          // Authenticated Home Page
          <>
            <span className="decorative-icon chat-bubble">💬</span>
            <h1>Welcome Back, {nickname}!</h1>
            <p className="home-tagline">Under Testing</p>
            <Link to="/chat">
              <button className="home-button">Go to Chat</button>
            </Link>
          </>
        ) : (
          // Unauthenticated Home Page
          <>
            <span className="decorative-icon chat-bubble">💬</span>
            <h1>Join the Cloud Top Community!</h1>
            <p className="home-tagline">Under Testing</p>
            <div className="home-buttons">
              <Link to="/signup">
                <button className="home-button">Get Started</button>
              </Link>
              <Link to="/login">
                <button className="home-button">Sign In</button>
              </Link>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default Home;